import React, { useState, useEffect } from 'react';
import HeadSub from '../../../../../components/comm/HeadSub';
import { useNavigate } from "react-router-dom";
import URL from "../../../../../constants/url";
import style from './PreQuestionMain.module.css';
import imgMiddleMain from "../../../../../images/user/i_pre_question_main.svg";



const PreQuestionMain = () => {

    const navigate = useNavigate();

    return (
        <>
            <HeadSub title="혈액암 수술 내원 전 사전 질문지 어쩌고 저쩌고 길어짐 어쩌고 저쩌고 길어짐 길어짐 길어짐" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap'>
                    
                    <div className={style['mid-box']}>
                        <strong className={style['title']}>25.00.00(수) 까지 작성해주세요!</strong>
                        <span className={style['round-box']}>10일 남음</span>
                        <div className={style['img-box']}>
                            <object data={imgMiddleMain} alt="" aria-hidden='true'/>
                        </div>
                        <div className={style['infom-box']}>
                            <ul>
                                <li>
                                    <p>병원</p>
                                    <span>여의도성모</span>
                                </li>
                                <li>
                                    <p>진료과</p>
                                    <span>혈액내과</span>
                                </li>
                                <li>
                                    <p>작성 요청</p>
                                    <span>혈액암 수술 내원 전 사전 설문지</span>
                                </li>
                                <li>
                                    <p>작성 안내</p>
                                    <span>이건 무슨무슨 설문지고 이런저런 목적으로 하는거고 어쩌고 저쩌고 안내 사항을 줄글로 노출합니다. 성실하게 답변해주세요</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    
                    <div className="bottom-fixed-box" data-height="auto">
                        <div className="inner-box">
                            <div className='btn-layout' data-btn-num="1" data-btn-direction="column">
                                <strong className={style['strong-txt']}>약 1분 정도 소요됩니다!</strong>
                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={()=> navigate(URL.PRE_QUESTION)}>
                                    <span>작성 시작</span>
                                </button>
                            </div>
                        </div>
                    </div>
                   


                </div>
            </div>
            
        </>
    )
}

export default PreQuestionMain